module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"method":"Method: ","address":"Address: ","parameters":"Parameters: ","url":"url: The URL to be shortened","title":"title(optional): Customize title","format":"format(optional): Response format [json jsonp xml simple]"},"zh":{"method":"请求方法：","address":"请求地址：","parameters":"请求参数：","url":"url: 要压缩的网址","title":"title(可选): 自定义标题","format":"format(可选): 响应格式 [json jsonp xml simple]"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/api.vue
// module id = 17
// module chunks = 0